var map = {
	"./advertising-materials.svg": "a646",
	"./agreement-template.svg": "9555",
	"./announcements.svg": "0e0a",
	"./contract-template-operational-manual.svg": "0325",
	"./drs.svg": "94f2",
	"./newspaper-materials.svg": "c20f",
	"./operations-manual.svg": "4eb0",
	"./partners-council.svg": "e304",
	"./purchasing-group-equal-in-business.svg": "f204",
	"./retr.svg": "4ad2",
	"./retrodiscounts-services-manual.svg": "881b",
	"./terms-of-business.svg": "5c1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1699";